import { PetalsTabWidget } from "./widget/PetalsTabWidget";
import { TulipAssetConstant } from "../TulipAssetConstants";
import { EntityManager } from "../../cocos/scripts/plan/EntityManager";
import { PlanManager } from "../../cocosPlan";
import { Events, eventsManager, Listener } from "@rhinov/savane-js";

export class TulipModalController {

    OFFSET: number = 15;//px
    //Triangle dimensions (px)
    TR_H: number = 20;
    TR_W: number = 40;
    TR_ID: string = 'awesome-triangle';
    TR_COLOR: string = '#efefef';//FIXME this should be a param of tulip ?

    tulip_dir_top = true;
    superGame: HTMLElement = document.getElementById('superGame')!;
    boundingBox: { top: number; left: number; width: number; height: number; } | null = null;
    petalwidget: PetalsTabWidget | null = null;
    designer: any;
    deliverable: any;
    user: any;
    urlconfig: string;
    openAssetDetailCallback: CallableFunction;
    element: HTMLElement | null = null;
    showListener: Listener | null = null;
    hideListener: Listener | null = null;
    floorListener: Listener | null = null;
    tulip_align_left: string = 'center';
    wallSpecial: boolean = false;

    constructor(urlconfig: any, openAssetDetailCallback: CallableFunction, deliverable: any, user: any, designer: any) {
        TulipAssetConstant.getinstance();
        this.designer = designer;
        this.deliverable = deliverable;
        this.user = user;
        this.urlconfig = urlconfig;
        this.openAssetDetailCallback = openAssetDetailCallback;

        //Force call to resize to init bounding box
        if (this.superGame) {
            this.resizeCallback();
        }
        //Init
        eventsManager.instance.addListener(Events.PROJECT_DID_LOAD,
            (() => {
                this.resizeCallback();
                return Events.UNREGISTER;
            }).bind(this));
        //Set element as flexbox
        const tulipElement = document.getElementById("tulip-plan");  // trashcode ?
        if (tulipElement) {
            this.element = tulipElement;
            this.element.style.flexWrap = 'no-wrap';
            this.element.style.justifyContent = 'flex-start';
            this.element.style.display = 'none';
        }
        //Listen to show event
        const showListener = eventsManager.instance.addListener(Events.SHOW_TULIP, this.showEvent.bind(this));
        if (showListener) {
            this.showListener = showListener;
        }
        const hideListener = eventsManager.instance.addListener(Events.HIDE_TULIP, this.hideEvent.bind(this));
        if (hideListener) {
            this.hideListener = hideListener;
        }
        const floorListener = eventsManager.instance.addListener(Events.PLAN_FLOOR_CHANGED, this.hideEvent.bind(this));
        if (floorListener) {
            this.floorListener = floorListener;
        }
        //Tulip
        window.addEventListener('resize', this.resizeCallback);
    }

    // Check collisions with entities others than the ones managed by savane managers
    collisionWithCursor(entity: any, cursorPosition: any) {
        // Get cocos node
        var node = EntityManager.getInstance().getNodeById(entity.id);

        // Node found ? Check collision
        if (node !== null && cursorPosition) {
            // Get node width and height for collision
            var halfNodeWidth;
            var halfNodeHeight;
            var convertedPos = node.convertToNodeSpace(cursorPosition);

            if (entity.isArrangementObjectEntity()) {
                halfNodeWidth = (node.getWidth() * node._sprite.getScaleX()) / 2;
                halfNodeHeight = (node.getHeight() * node._sprite.getScaleY()) / 2;
            }
            else {
                halfNodeWidth = (entity.length / 10) / 2;
                if (!entity.isWallEntity()) {
                    halfNodeHeight = (entity.width / 10) / 2;
                }
                else {
                    halfNodeHeight = (entity.thickness / 10) / 2;
                }
            }

            // Check minimal size width and height and force them to a minimum size to be sure to be able to collide the element
            if (halfNodeWidth < 4) {
                halfNodeWidth = 4;
            }
            if (halfNodeHeight < 4) {
                halfNodeHeight = 4;
            }

            if (!entity.isWallEntity()) {
                if (convertedPos.x > -halfNodeWidth && convertedPos.x < halfNodeWidth && convertedPos.y > -halfNodeHeight && convertedPos.y < halfNodeHeight) {
                    return (true);
                }
            }
            else {
                if (convertedPos.x > 0 && convertedPos.x < halfNodeWidth * 2 && convertedPos.y > -halfNodeHeight && convertedPos.y < halfNodeHeight) {
                    return (true);
                }
            }
        }

        return (false);
    };

    graphicalInitTulip(item: any) {
        //Graphical init
        if (!this.element) {
            return;
        }
        this.element.style.position = 'absolute';
        var tulipPosition = {
            left: PlanManager.getInstance().CanvasMouseX,
            top: PlanManager.getInstance().CanvasMouseY
        };

        if (!PlanManager.getInstance().frontViewLayer.isVisible()) {
            // In case on an arrangement object or group
            if (!Array.isArray(item)) {
                if (item.isIArrangementEntity() || item.isJoineryEntity() || item.isWallEntity() || item.isRenderCameraEntity()) {
                    // Check if the cocos cursor position is still above the selected object
                    var cursorPosition = PlanManager.getInstance()._uiState.cocosPosition;

                    // If it is not the case, we come from a WebGL click (the mouse cursor is out of the CocosPlan area)
                    if (!this.collisionWithCursor(item, cursorPosition)) {
                        // Get cocos node
                        var node = EntityManager.getInstance().getNodeById(item.id);

                        // Node found ?
                        if (node !== null) {
                            // Get the node screen coordinate (cocos)
                            var position = node.parent.convertToWorldSpace(node.getPosition());

                            // left is X in our case
                            tulipPosition.left = position.x;
                            // But top is height of the cocos area - cocos Y coordinate
                            tulipPosition.top = this.superGame.clientHeight - position.y;
                        }
                    }
                }
            }
            else {
                var collision = false;
                var positionX = 0;
                var positionY = 0;
                var allArrangement = true;

                for (var i = 0; i < item.length; i++) {
                    if (item[i].isIArrangementEntity()) {
                        // Check if the cocos cursor position is still above the selected object
                        var cursorPosition = PlanManager.getInstance()._uiState.cocosPosition;

                        // If it is not the case, we come from a WebGL click (the mouse cursor is out of the CocosPlan area)
                        if (!this.collisionWithCursor(item[i], cursorPosition)) {
                            // Get cocos node
                            var node = EntityManager.getInstance().getNodeById(item[i].id);

                            // Node found ?
                            if (node !== null) {
                                // Get the node screen coordinate (cocos)
                                var position = node.parent.convertToWorldSpace(node.getPosition());

                                // Accumulate x and y positions to compute average
                                positionX += position.x;
                                positionY += position.y;
                            }
                        }
                        else {
                            collision = true;
                            break;
                        }
                    }
                    else {
                        allArrangement = false;
                        break;
                    }
                }

                if (allArrangement && !collision) {
                    positionX /= item.length;
                    positionY /= item.length;

                    // left is X in our case
                    tulipPosition.left = positionX
                    // But top is height of the cocos area - cocos Y coordinate
                    tulipPosition.top = this.superGame.clientHeight - positionY;
                }
            }
        }

        //Check decal
        if (!this.boundingBox) {
            return;
        }
        var xRate = tulipPosition.left / this.boundingBox.width;
        var yRate = tulipPosition.top / this.boundingBox.height;
        //Use percent of screen to find the side where we have the largest dist to display tulip
        var left = xRate >= 0.5;
        var top = yRate >= 0.5;

        //Check if already exist and add triangle
        var triangle = document.getElementById(this.TR_ID);
        if (!triangle) {
            //triangle didn't exist create dom element
            const div = document.createElement('div');
            div.id = this.TR_ID;
            div.style.width = '0';
            div.style.height = '0';
            div.style.borderStyle = 'solid';
            this.element.prepend(div);
            triangle = document.getElementById(this.TR_ID);
        }

        //Decal using element size
        if (top) {
            tulipPosition.top -= this.element.clientHeight + this.OFFSET;
            //Change flex direction
            this.element.style.flexDirection = 'column-reverse';
            if (triangle) {
                triangle.style.borderWidth = this.TR_H + 'px ' + this.TR_H + 'px 0 ' + this.TR_H + 'px';
                triangle.style.borderColor = this.TR_COLOR + ' transparent transparent transparent';
            }
        } else {
            tulipPosition.top += this.OFFSET;
            //Change flex direction
            this.element.style.flexDirection = 'column';
            if (triangle) {
                triangle.style.borderWidth = '0 ' + this.TR_H + 'px ' + this.TR_H + 'px ' + this.TR_H + 'px';
                triangle.style.borderColor = 'transparent transparent ' + this.TR_COLOR + ' transparent';
            }
        }
        //Set controller value
        this.tulip_dir_top = top;

        //tulipPosition.left -= $(element).width() *0.5 ;

        if (this.boundingBox && left && tulipPosition.left + this.element.clientWidth * 0.5 >= this.boundingBox.width) {
            this.tulip_align_left = 'left';
            tulipPosition.left -= this.element.clientWidth - this.TR_W * 0.5;                              //wallspecial = trashcode
            this.element.style.alignItems = 'flex-end';
        } else if (!this.wallSpecial && !left && tulipPosition.left - this.element.clientWidth * 0.5 <= 0) {
            tulipPosition.left -= this.TR_W * 0.5;
            this.element.style.alignItems = 'flex-start';
            this.tulip_align_left = 'right';
        } else {
            tulipPosition.left -= this.element.clientWidth * 0.5;
            this.element.style.alignItems = 'center';
            this.tulip_align_left = 'center';
        }

        var gameCanvas = document.getElementById('gameCanvas');
        var parentElement = this.element.parentElement;
        if (gameCanvas && parentElement) {
            //Calculate diff from parent to gameCanvas
            var diffLeft = gameCanvas.getBoundingClientRect().left - parentElement.getBoundingClientRect().left;
            var diffTop = gameCanvas.getBoundingClientRect().top - parentElement.getBoundingClientRect().top;
            //
            var newLeft = diffLeft + tulipPosition.left;
            var newTop = diffTop + tulipPosition.top + this.superGame.scrollTop;
            this.element.style.left =  newLeft + 'px';
            this.element.style.top = newTop + 'px';
        }
    };

    showEvent (event: any) {
        //Show tulip
        if (this.element) {
            this.element.style.display = 'flex';
        }
        //Graphically set tulip
        this.graphicalInitTulip(event.userData.obj);
        if(!this.petalwidget) {
            this.petalwidget = new PetalsTabWidget(event.userData.obj, this.urlconfig, this.openAssetDetailCallback, this.deliverable, this.user, this.designer);
        } else {
            this.petalwidget.destroy();
            this.petalwidget = new PetalsTabWidget(event.userData.obj, this.urlconfig, this.openAssetDetailCallback, this.deliverable, this.user, this.designer);
        }
    };

    hideEvent() {
        //Hide tulip
        if (this.element) {
            this.element.style.display = 'none';
        }
        if (this.petalwidget) {
            this.petalwidget.destroy();
            this.petalwidget = null;
        }
        // if (typeof this.cleanTulipItemListener == 'function') {
        //     this.cleanTulipItemListener();
        // }
        eventsManager.instance.dispatch(Events.START_UPDATING_ENVS);
    };
    /**
     * Reset orgin
     */
    resizeCallback() {
        if (this.superGame) {
            this.boundingBox = {
                top: this.superGame.offsetTop,
                left: this.superGame.offsetLeft,
                width: this.superGame.offsetWidth,
                height: this.superGame.offsetHeight,
            };
        }
    };
    

    //On destroy
    destroy() {
        if(this.petalwidget) {
            this.petalwidget.destroy();
        }
        if (this.showListener) {
            eventsManager.instance.removeListener(this.showListener);
        }
        if (this.hideListener) {
            eventsManager.instance.removeListener(this.hideListener);
        }
        if (this.floorListener) {
            eventsManager.instance.removeListener(this.floorListener);
        }
        window.removeEventListener('resize', this.resizeCallback);
    };
}